<ng-template #modalTmpl>
  <h1 mat-dialog-title>{{ 'modals.creadit-account.title' | transloco }}</h1>

  <div mat-dialog-content class="max-h-80vh py-24px px-16px">
    <div class="text-center">
      {{ 'modals.creadit-account.msg-iban' | transloco }}:
    </div>

    <div class="my-36px text-center text-secondary">
      <b>
        {{ iban }}
      </b>
    </div>

    <!-- 200XXXX (it will be last 7 characters from investor ID) -->
    <div class="text-center py-8px">
      <span>
        {{ 'modals.creadit-account.msg-reference' | transloco }}:
        <b>{{ reference }}</b></span
      >
    </div>
  </div>

  <div
    mat-dialog-actions
    class="border-t border-border-d flex justify-end items-center"
  >
    <div class="flex justify-end items-center grow">
      <button
        mat-button
        mat-dialog-close
        class="ib-btn-outline ib-btn-secondary mr-16px"
      >
        {{ 'btn.close' | transloco }}
      </button>
    </div>
  </div>
</ng-template>
